
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";

import { ErrorProvider } from "./context/ErrorContext";
import { HeroUIProvider } from "@heroui/react";

import NotFound from "./pages/NotFound"; // Import the NotFound component
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { msalInstance } from ".";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import { EntityProvider } from "./context/EntityContext";
import Ingestion from "./pages/Ingestion";
import ReportPage from "./pages/ReportPage";
import StatusPage from "./pages/StatusPage";
import UploadPage from "./pages/UploadPage";
import { useSessionManager } from "./hooks/useSessionManager";
import Splash from "./components/Splash";
import { isE2EModeEnabled } from "./utils/runtimeMode";

const AppAuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (isE2EModeEnabled()) {
    return <>{children}</>;
  }

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{ ...loginRequest }}
    >
      <>{children}</>
    </MsalAuthenticationTemplate>
  );
};

const App: React.FC = () => {
  // console.log("login request", {...loginRequest})
  // useSessionManager({ idleTimeoutMS: 30 * 1000 });// change timer for testing locally

  useSessionManager({ disabled: isE2EModeEnabled() });
  
  return (
    <MsalProvider instance={msalInstance}>
      <AppAuthGate>
            <ErrorProvider>
              <HeroUIProvider>
              <ToastContainer position="top-right" autoClose={3000} />
                <Router>
                  <EntityProvider>
                  <Routes>
                    {/* <Route path="/" element={<Navigate to="/upload" />} /> */}
                    {/* <Route path="/upload" element={<UploadPage />} /> */}
                    <Route path="/" element={<Splash />} />
                    <Route path="/upload" element={<UploadPage />} />
                    <Route path="/report" element={<ReportPage/>} />
                    <Route path="/status" element={<StatusPage />} />
                    <Route path="/ingestion" element={<Ingestion />} />
                    <Route path="*" element={<NotFound />} />
                    {/* Catch-all route */}
                  </Routes>
                  </EntityProvider>
                </Router>
              </HeroUIProvider>
            </ErrorProvider>
      </AppAuthGate>
      </MsalProvider>
  );
};

export default App;
